import UseCookie from './UseCookie.vue';

export default UseCookie;



// WEBPACK FOOTER //
// ./src/components/usecookie/index.ts